import React, { useEffect } from "react";

const PrivacyModal = ({ isOpen, onClose }) => {
  // Prevent background scroll
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center animate-fadeIn"
      onClick={onClose} // click background closes
    >
      {/* 🔲 Dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60" />

      {/* 📦 Modal content */}
      <div
        className="relative bg-white max-w-lg w-full mx-4 p-6 rounded-lg shadow-lg z-10"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        {/* ❌ Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-black"
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold mb-4">Privacy Policy</h2>

        <p className="text-gray-700 text-sm leading-relaxed">
          This website uses Microsoft Clarity to understand how visitors interact
          with the site through anonymized analytics such as clicks, scrolling,
          and navigation behavior. This helps improve the overall user experience.
          No personally identifiable information is intentionally collected.
        </p>
      </div>
    </div>
  );
};

export default PrivacyModal;